export default function LogoSmall() {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 614 624"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        transform="translate(0,624) scale(0.1,-0.1)"
        fill="#000000"
        stroke="none"
      >
        <path
          d="M2941 6214 c-174 -47 -306 -192 -346 -379 -19 -89 -19 -163 0 -261
39 -203 138 -409 298 -618 l60 -80 -59 -54 c-84 -78 -201 -163 -261 -191 l-52
-24 -38 30 c-91 72 -270 181 -413 252 -488 242 -1020 307 -1303 159 -83 -43
-194 -156 -235 -236 -91 -184 -59 -396 82 -538 114 -114 316 -169 588 -162
l107 2 143 -71 c236 -118 428 -256 602 -432 l89 -90 -49 -58 c-72 -86 -215
-233 -226 -233 -5 0 -44 26 -86 59 -543 413 -1094 549 -1472 363 -104 -51
-214 -160 -264 -262 -136 -277 -39 -608 228 -781 221 -144 572 -145 920 -4
192 78 382 187 577 331 48 35 91 64 96 64 12 0 192 -185 241 -247 l33 -42 -88
-87 c-173 -173 -378 -319 -610 -435 l-131 -66 -99 5 c-268 13 -487 -49 -603
-169 -184 -189 -173 -463 26 -666 128 -131 264 -177 524 -177 408 1 881 169
1286 460 l79 57 62 -33 c71 -36 160 -102 247 -182 l59 -54 -74 -99 c-137 -185
-225 -358 -270 -530 -32 -126 -33 -282 -1 -382 44 -141 157 -263 289 -313 88
-34 221 -39 311 -11 164 50 282 177 323 351 29 124 10 315 -47 467 -53 140
-158 324 -263 457 l-46 59 75 69 c78 72 238 185 277 194 16 4 38 -6 80 -38
536 -408 1325 -592 1697 -395 130 68 247 223 276 364 35 165 -35 343 -175 450
-108 82 -242 114 -487 119 l-167 2 -125 62 c-225 111 -430 257 -604 430 l-92
92 32 41 c49 62 229 247 240 247 6 0 58 -35 117 -78 265 -196 524 -326 779
-389 94 -24 126 -27 272 -28 186 0 244 11 365 71 128 62 230 164 289 289 111
232 69 495 -108 671 -118 117 -245 174 -436 193 -342 36 -779 -126 -1192 -440
-42 -33 -81 -59 -86 -59 -11 0 -154 147 -227 234 l-49 58 114 112 c178 175
359 302 599 421 l111 56 167 3 c309 6 470 64 578 208 145 193 119 445 -65 629
-173 173 -463 220 -858 138 -325 -66 -710 -240 -963 -435 -32 -24 -63 -44 -69
-44 -37 0 -249 150 -329 233 l-33 35 65 87 c294 392 380 786 229 1044 -56 95
-165 178 -276 207 -66 18 -186 17 -255 -2z m265 -177 c162 -82 217 -294 139
-537 -36 -114 -131 -296 -210 -402 -36 -49 -68 -88 -72 -88 -11 0 -105 133
-163 230 -127 212 -180 445 -135 596 56 190 271 288 441 201z m-1744 -1096
c279 -48 587 -172 842 -338 l111 -72 -30 -11 c-187 -74 -532 -166 -762 -206
-252 -43 -548 -47 -671 -11 -156 47 -245 149 -246 285 -1 177 145 332 344 365
76 13 306 6 412 -12z m3646 4 c133 -31 230 -106 283 -218 70 -150 14 -318
-131 -392 -155 -78 -489 -77 -891 5 -206 42 -610 161 -642 189 -10 10 156 117
293 189 201 105 437 187 655 226 109 19 352 20 433 1z m-1883 -331 c33 -27 85
-64 115 -83 30 -19 57 -36 59 -38 2 -1 -39 -47 -91 -101 -52 -54 -125 -139
-163 -188 -38 -49 -71 -92 -75 -97 -4 -4 -40 37 -82 90 -41 54 -117 142 -168
196 -51 54 -91 99 -89 101 2 2 29 19 59 38 67 42 192 143 240 192 l34 36 51
-48 c27 -27 77 -71 110 -98z m-558 -302 c113 -113 198 -216 284 -344 89 -131
133 -138 203 -32 102 156 258 341 360 429 l55 46 128 -47 c70 -26 131 -50 135
-53 4 -4 -27 -33 -70 -66 -100 -78 -292 -268 -372 -370 -108 -137 -180 -251
-180 -285 0 -59 67 -98 120 -70 11 6 40 43 66 83 145 224 379 462 605 615 l46
31 79 -21 c43 -11 137 -32 208 -47 l129 -27 -100 -62 c-314 -193 -568 -434
-762 -725 -31 -46 -53 -90 -53 -107 -2 -63 56 -104 109 -78 22 10 100 113 152
198 8 12 17 6 47 -30 21 -25 79 -88 130 -140 l92 -95 -130 -134 c-71 -74 -132
-131 -136 -125 -4 5 -35 51 -70 102 -71 104 -94 120 -147 98 -35 -15 -52 -49
-46 -91 5 -32 135 -215 235 -332 166 -193 396 -382 630 -518 l49 -29 -129 -27
c-71 -15 -165 -36 -208 -47 l-79 -21 -57 39 c-224 152 -429 361 -591 601 -32
47 -65 89 -74 93 -33 12 -66 6 -90 -19 -41 -40 -33 -72 44 -187 130 -194 303
-380 486 -524 41 -33 71 -62 67 -65 -4 -4 -64 -28 -135 -54 l-127 -47 -55 47
c-103 88 -256 269 -349 413 -68 104 -121 117 -174 42 -15 -21 -55 -78 -89
-126 -66 -94 -191 -235 -285 -323 l-57 -53 -128 47 c-71 26 -131 51 -135 54
-4 4 25 31 65 61 212 161 557 569 557 660 0 59 -67 98 -120 70 -11 -6 -40 -43
-66 -83 -146 -227 -369 -454 -594 -607 l-57 -39 -79 21 c-43 11 -137 32 -208
47 l-129 27 112 69 c224 139 410 296 564 475 103 120 233 303 238 335 6 42
-11 76 -47 91 -51 21 -79 4 -139 -87 -27 -41 -58 -86 -67 -99 l-17 -23 -130
134 -129 134 92 95 c51 52 109 115 130 140 30 36 39 42 47 30 53 -87 131 -188
153 -198 38 -19 84 1 101 42 16 38 6 65 -56 158 -185 276 -445 522 -753 711
l-99 61 151 32 c83 18 176 40 207 49 l56 16 67 -47 c228 -161 426 -362 569
-577 36 -54 74 -102 84 -107 31 -17 69 -11 94 15 41 40 33 72 -44 187 -130
194 -285 362 -476 516 -44 35 -81 67 -82 71 -3 6 240 98 264 100 6 1 56 -43
110 -97z m-1660 -776 c238 -66 467 -181 705 -355 43 -31 77 -59 78 -64 0 -12
-178 -139 -290 -207 -477 -288 -915 -328 -1149 -106 -125 120 -171 288 -121
448 48 155 172 263 350 303 101 23 309 14 427 -19z m4535 19 c275 -58 428
-287 363 -540 -42 -160 -162 -277 -340 -331 -91 -28 -301 -25 -420 5 -115 29
-267 88 -392 152 -147 76 -429 267 -413 282 3 2 42 32 88 65 270 199 571 336
822 375 62 10 231 5 292 -8z m-2397 -1519 c38 -49 111 -134 163 -188 52 -54
93 -100 91 -101 -2 -2 -31 -20 -64 -41 -73 -47 -143 -103 -213 -170 -39 -38
-56 -48 -66 -41 -7 6 -51 43 -97 83 -46 40 -115 94 -154 119 -38 26 -72 48
-74 49 -2 2 38 47 89 101 51 54 127 142 168 196 42 53 78 94 82 90 4 -5 37
-48 75 -97z m-1545 -105 c227 -39 556 -127 754 -201 l59 -23 -113 -73 c-128
-83 -311 -176 -450 -229 -119 -46 -327 -99 -447 -115 -135 -18 -361 -8 -438
19 -295 105 -350 467 -92 597 90 46 152 54 387 50 160 -3 247 -9 340 -25z
m3553 10 c99 -26 144 -50 193 -103 58 -63 78 -121 72 -210 -9 -129 -87 -241
-211 -299 -93 -43 -159 -52 -347 -46 -231 7 -415 52 -690 168 -116 49 -328
167 -411 227 l-41 31 36 15 c155 65 522 163 749 200 198 33 193 33 398 34 145
2 189 -1 252 -17z m-2018 -798 c74 -99 196 -337 220 -428 9 -33 19 -103 22
-156 5 -82 2 -107 -16 -169 -19 -62 -31 -81 -79 -130 -44 -43 -70 -60 -116
-74 -151 -47 -317 28 -384 173 -31 68 -41 198 -22 294 17 88 81 248 139 345
59 98 153 232 164 232 4 0 37 -39 72 -87z"
        />
      </g>
    </svg>
  )
}
